module.exports = __webpack_public_path__ + "static/media/icon-agent.c35f4c7f.svg";